import { render, staticRenderFns } from "./insureRule.vue?vue&type=template&id=c6e2ebd4&scoped=true"
import script from "./insureRule.vue?vue&type=script&lang=js"
export * from "./insureRule.vue?vue&type=script&lang=js"
import style0 from "./insureRule.vue?vue&type=style&index=0&id=c6e2ebd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e2ebd4",
  null
  
)

export default component.exports